export default {
    // récuperer toutes les roles dans la base de données 
    get_auth_roles(tokens){
        return axios.get('/authroles', {
            headers: {
                Authorization: "Bearer " + tokens
            }
        }) 
    },
    get_all_roles(){
        return axios.get('/roles', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les roles dans la base de données 
    post_roles(role){
        return axios.post('/roles',role, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    get_roles_by_entite(entite_id){
        return axios.post('/role/list',entite_id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    get_roles_by_role(role){
        return axios.post('/role/possible/list',role, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_roles(id){
        return axios.get('/roles/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_roles(id){
        return axios.delete('/roles/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}